<template>
  <div class="home-swiper">
    <div class="swiper-container1">
      <div class="swiper-wrapper">
        <img v-for="item in swiperList" :key="item.title" class="swiper-slide" :src="item.imgUrl" alt="">
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-next1"></div>
      <div class="swiper-button-prev1"></div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper' // 注意引入的是Swiper
import 'swiper/css/swiper.min.css' // 注意这里的引入

export default {
  data () {
    return {
      swiperList: [
        {
          title: 'image-1',
          imgUrl: require('@/assets/imgs/banner-01.png')
        },
        {
          title: 'image-2',
          imgUrl: require('@/assets/imgs/banner-02.png')
        },
        {
          title: 'image-3',
          imgUrl: require('@/assets/imgs/banner-03.png')
        },
        {
          title: 'image-4',
          imgUrl: require('@/assets/imgs/banner-04.png')
        }
      ]
    }
  },
  mounted () {
    this.getSwiper()
  },
  methods: {
    getSwiper () {
      this.swiper = new Swiper('.swiper-container1', {
        loop: true, // 无缝
        autoplay: { // 自动开始
          delay: 2000, // 时间间隔
          disableOnInteraction: false //* 手动操作轮播图后不会暂停*
        },
        paginationClickable: true,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next1',
          prevEl: '.swiper-button-prev1'

        },
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true // 分页器可以点击
        }
      })
    }
  }

}
</script>
<style lang="scss" scoped>
.home-swiper {
  width: 100%;
  overflow-x: hidden;
  .swiper-container1 {
    width: 100%;
    height: 100%;
  }
  .swiper-container1:hover{
    cursor: pointer;
    .swiper-button-next1{
      opacity: 1;
    }
    .swiper-button-prev1{
      opacity: 1;
    }
  }
  .swiper-slide {
    position: relative;
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #f7f8fa;
  }
  .swiper-button-next1 {
    width: 75px;
    height: 75px;
    background: url("../../assets/imgs/next-01.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: calc(50% - 25px);
    right: 80px;
    cursor: pointer;
    z-index: 999;
    opacity: 0;
  }
  .swiper-button-prev1 {
    width: 75px;
    height: 75px;
    background: url("../../assets/imgs/prev-01.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: calc(50% - 25px);
    left: 76px;
    cursor: pointer;
    z-index: 999;
    opacity: 0;
  }

  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 153px;
  }
}
@media (max-width: 1680px) {
// .home-three .catchword{
//     top:-200px
//   }
.home-swiper .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 200px;
  }

}

</style>
